import { Link, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '模板中心', path: '/category/all' },
      { label: '建站学院', path: '/articles' },
      { label: '功能介绍', path: '/#features' },
      { label: '常见问题', path: '/#faq' },
    ],
  },
  company: {
    title: '公司',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '用户口碑', path: '/about#reputation' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '帮助中心', path: '/articles' },
      { label: '建站教程', path: '/articles?category=tutorial' },
      { label: 'SEO指南', path: '/articles?category=seo' },
    ],
  },
};

export default function Footer() {
  const location = useLocation();

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link
              to="/"
              onClick={scrollToTop}
              className="text-2xl font-heading text-background-50 inline-block mb-4 cursor-pointer"
            >
              易建站
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed">
              零门槛在线建站平台，无需编程，拖拽即可创建专业网站。超过500万用户的选择，让每个人都能轻松拥有自己的网站。
            </p>
          </div>

          {Object.entries(footerLinks).map(([key, section]) => (
            <div key={key}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{section.title}</h4>
              <ul className="flex flex-col gap-3">
                {section.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      onClick={scrollToTop}
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/50">
            &copy; {new Date().getFullYear()} 易建站. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="#"
              className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-sm text-background-50/50 hover:text-background-50/80 transition-colors duration-200"
              rel="nofollow"
            >
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}